import React from "react";
import '../../../styles/experience.css';


const Experience=()=>{
    return(
        <div className="experience">
            <h3>Experience</h3>
            <div className="experienceDetails">
                <ul className="listVertical">
                    <li className="innerList"></li>
                    <li className="innerList"></li>
                </ul>
                <ul className="experienceAnswer">
                    <li>
                        <div>
                            <h4 className="expName">Cyber Security Analyst</h4>
                        </div>
                        <ul>
                            <li>Through my collaboration on vulnerability disclosure programs, I helped several companies strengthen their security measures and protect themselves from potential attacks.</li>
                            <li>Companies recognized me for discovering severe vulnerabilities, adding me to their Hall of Fame, and rewarding me for my work.</li>
                            <li>I researched open-source vulnerability disclosure programs and identified severe vulnerabilities.</li>
                            <li>I have experience in web application testing using tools like Burp, Dirbuster, Metasploit, Sqlmap, and manual techniques.</li>
                        </ul>
                    </li>
                    <li>
                        <div>
                        <div>
                            <h4 className="expName">Front End Developer</h4>
                        </div>
                        <ul>
                            <li>Developed responsive websites and pages using HTML, CSS, and Javascript.</li>
                            <li>Designed, implemented, and monitored web pages and sites to ensure continuous improvements.</li>
                            <li>Applied responsive design techniques and principles of mobile optimization to optimize web app pages for various screen sizes and devices.</li>
                            <li>Designed and developed a personal portfolio webpage using HTML, CSS, and Javascript, with a fully responsive layout optimized for various screen sizes and devices.</li>
                        </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default Experience;